const {Component} = require("react");
const {PropTypes} = require("prop-types");
const router = require("app/services/router");
const renderer = require("app/services/renderer");

class Trigger extends Component {

	static get propTypes() {
		return {
			containerSelector: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			containerSelector: ".desktop-search"
		}
	}

	get toggled() {
		let body = document.body;
		let classList = body.className.split(" ");

		return classList.indexOf("show-search") > -1;
	}

	toggle(state) {
		let body = document.body;
		let classList = body.className.split(" ");
		let index = classList.indexOf("show-search");

		if (state) {
			if (index === -1) {
				classList.push("show-search");

				const searchWidget = renderer.element("search-widget");

				if (searchWidget) {
					searchWidget.focus();
				}
			}
		}
		else {
			if (index > -1) {
				classList.splice(index, 1);
			}
		}

		body.className = classList.join(" ");
	}

	_onClick = (e) => {
		e.preventDefault();
		this.toggle(!this.toggled);
	};

	render() {
		return (
			<a href="#" onClick={this._onClick}>
				<div className={'sprite'} lazy-load={'true'} critical={'true'}
                     cssbg={router.url("img/icons/icons-black@2x.png")}/>
			</a>
		);
	}

}

module.exports = Trigger;
